const classPrefix = 'banner-results'
const dataPrefix = 'data-banner-results'
const $container = document.querySelector(`[${dataPrefix}]`)


export function bannerResults() {


}
